window.addEventListener('DOMContentLoaded', () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const htmlElement = document.documentElement;

  // Detect device type
  const isMobile = /iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(userAgent);
  htmlElement.classList.add(isMobile ? 'mobile' : 'desktop');

  // Detect browser
  if (/firefox/.test(userAgent)) {
    htmlElement.classList.add('firefox');
  } else if (/edge|edg/.test(userAgent)) {
    htmlElement.classList.add('edge');
  } else if (/chrome/.test(userAgent) && !/edge|edg/.test(userAgent)) {
    htmlElement.classList.add('chrome');
  } else if (/safari/.test(userAgent) && !/(chrome|crios|fxios)/.test(userAgent)) {
    htmlElement.classList.add('safari');
  } else if (/opera|opr/.test(userAgent)) {
    htmlElement.classList.add('opera');
  } else {
    htmlElement.classList.add('unknown-browser');
  }

  // Detect OS/Platform
  if (/mac/.test(userAgent)) {
    htmlElement.classList.add('macos');
  } else if (/win/.test(userAgent)) {
    htmlElement.classList.add('windows');
  } else if (/linux/.test(userAgent)) {
    htmlElement.classList.add('linux');
  } else if (/iphone|ipad|ipod/.test(userAgent)) {
    htmlElement.classList.add('ios');
  } else if (/android/.test(userAgent)) {
    htmlElement.classList.add('android');
  } else {
    htmlElement.classList.add('unknown-os');
  }
})